import React, { useEffect, useState, useRef } from 'react';
import { SwiperSlide, Swiper } from 'swiper/react';
import { Autoplay, EffectCoverflow, Pagination, Navigation } from 'swiper';
import PartSlide from "./partSlide";
import { useTranslation } from "react-i18next";
import axios from "axios";
import config from "../../../configuration/config";

const SectionSlideEpart = () => {
    const { t: trans, i18n } = useTranslation(["common", "inputs", "offers", "home"]);
    const lang = (i18n.language || 'ar');
    const swiperRef = useRef(null);
    const [slidEPartsList, setSlidEPartsList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getSparePartsSlide = () => {
        const body = { "lang": lang.toLowerCase() };

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/func_getSparePartsSlide`,
            data: body,
            method: "POST",
            responseType: "json"
        })
            .then((response) => {
                console.info("func_getSparePartsSlide:Coach > ", response.data);

                if (response.data && response.data.length > 0) {
                    setSlidEPartsList(response.data);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                console.info("func_getSparePartsSlide:Coach > ", error);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getSparePartsSlide();
    }, [lang]);

    // Handle window resize for responsive updates
    useEffect(() => {
        const handleResize = () => {
            if (swiperRef.current && swiperRef.current.swiper) {
                swiperRef.current.swiper.update();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (isLoading) {
        return (
            <div className="epart-slide-skeleton">
                <div className="epart-slide-skeleton__inner"></div>
            </div>
        );
    }

    return (
        <div
            className={`epart-slide-section md:px-60  ${slidEPartsList && slidEPartsList.length > 0 ? "" : "hidden"}`}
            dir={lang === "ar" ? "rtl" : "ltr"}
        >
            <Swiper
                ref={swiperRef}
                className="epart-slide-container"
                modules={[Autoplay, EffectCoverflow, Pagination, Navigation]}
                spaceBetween={30}
                slidesPerView={1}
                centeredSlides={true}
                loop={true}
                speed={1000}
                effect="coverflow"
                coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 200,
                    modifier: 2.5,
                    slideShadows: true,
                }}
                pagination={{
                    clickable: true,
                    dynamicBullets: true,
                }}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
                watchSlidesProgress={true}
                observer={true}
                observeParents={true}
                parallax={true}
                grabCursor={true}
                breakpoints={{
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        coverflowEffect: {
                            depth: 100,
                            modifier: 1.5,
                        },
                    },
                    576: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                        coverflowEffect: {
                            depth: 150,
                            modifier: 2,
                        },
                    },
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 40,
                        coverflowEffect: {
                            depth: 180,
                            modifier: 2.2,
                        },
                    },
                    992: {
                        slidesPerView: 1,
                        spaceBetween: 50,
                        coverflowEffect: {
                            depth: 200,
                            modifier: 2.5,
                        },
                    },
                    1200: {
                        slidesPerView: 1,
                        spaceBetween: 60,
                        coverflowEffect: {
                            depth: 250,
                            modifier: 3,
                        },
                    },
                }}
                onSlideChange={() => {
                    // Optional: Add analytics or tracking here
                }}
                onSwiper={(swiper) => {
                    // Preload images for better performance
                    setTimeout(() => {
                        swiper.update();
                    }, 100);
                }}
            >
                {slidEPartsList.map((slide, index) => (
                    <SwiperSlide key={index} className="epart-slide-item">
                        <div className="epart-slide-wrapper">
                            <PartSlide
                                viewSocialIcons={false}
                                BackOpicity={slide?.backOpacity || 0.7}
                                Titel={slide?.title}
                                Desc={slide?.description}
                                backImageUrl={config.mainURL + slide?.urlImage}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default SectionSlideEpart;